<template>
    <transition name="animate">
        <div
            class="md shopping-area"
            @click.stop
            v-if="shoppingCartInit"
        >
            <div class="shopping-area-inner">
                <div class="cp caption">
                    <span class="name">{{ $t('popup.shoppingcart.item.shoppingcart') }}</span>
                    <a class="remove" @click.prevent="hide"></a>
                </div>
                <template v-if="shoppingCartList.length">
                    <ul class="list">
                        <li
                            v-for="item in shoppingCartList"
                            :key="item.cart_sn"
                        >
                            <div class="div">
                                <div class="image">
                                    <div class="mask" :style="'background-image: url('+ item.imageurl +');'"></div>
                                    <img :src="item.imageurl">
                                </div>
                                <div class="essay">
                                    <div v-if="item.label" class="label">{{ $siteTool.getLabelClassName(item.label) }}</div>
                                    <div class="caption">{{ item.alias || item.product_s }}</div>
                                    <div class="p">
                                        <div class="type">{{ item.product_b }}-{{ item.product_m }}</div>
                                        <div class="price">{{ showPrice(item) }}</div>
                                        <div class="product-class">{{ $t('popup.shoppingcart.item.qty') }}: {{ item.qty }}
                                            <cpLabel
                                                themes="danger"
                                                text="KG"
                                            ></cpLabel>
                                        </div>
                                    </div>
                                </div>
                                <a class="remove" @click.prevent="removeFromCart(item)"></a>
                            </div>
                        </li>
                    </ul>
                    <div class="btn-area">
                        <cpBtn
                            themes="major"
                            icon="shopping_cart"
                            :text="$t('popup.shoppingcart.item.viewcart')"
                            extendClass="is-block"
                            @click.prevent="next"
                        ></cpBtn>
                    </div>
                </template>
                <template v-else>
                    <div class="list">
                        <mdCartNull></mdCartNull>
                    </div>
                </template>
            </div>
        </div>
        <div
            v-else
            class="md shopping-area is-loading"
        >
            <div class="shopping-area-inner">
                <mdLoading></mdLoading>
            </div>
        </div>
    </transition>
</template>

<script>
    import mdCartNull from '@/components/mdCartNull'
    import mdLoading from '@/components/mdLoading'
    import cpStatus from '@/components/cpStatus'
    import cpBtn from '@/components/cpBtn'
    import cpLabel from '@/components/cpLabel'

    import { mapState, mapMutations } from 'vuex'

    export default {
        components: {
            mdCartNull,
            mdLoading,
            cpStatus,
            cpBtn,
            cpLabel,
        },
        computed: {
            ...mapState([
                'user',
                'shoppingCart',
                'shoppingCartInit',
            ]),
            shoppingCartList: function(){
                return this.shoppingCart.filter(item => item.is_on_market);
            },
        },
        methods: {
            ...mapMutations([
                'changeShoppingCart',
            ]),
            showPrice: function(item){
                let _customer_need_date = item.customer_need_date,
                    $date = new Date();

                if( _customer_need_date ) {
                    $date = new Date(_customer_need_date);
                }

                let _date = $date.toLocaleDateString(),
                    _price = this.$siteTool.computedPrice(item, _date);

                if( typeof _price === 'number' ) {
                    return 'NT$ '+ this.$okaTool.numberToStringFormat(_price)
                }else {
                    return this.$t('site.func.pricealert');
                }
            },
            removeFromCart: async function(opt) {
                let _url = this.$siteTool.apiUrl({
                        class: 'ShoppingCart',
                        func: 'Delete',
                    }),
                    $condition = {
                        cart_sn: opt.cart_sn
                    }

                try {
                    await this.$http.post(_url, $condition);
                
                    this.changeShoppingCart({
                        func: 'remove',
                        data: opt,
                    });

                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                    dataLayer.push({
                        event: "remove_from_cart",
                        ecommerce: {
                            currency: "TWD",
                            value: opt.price * opt.qty,
                            items: [
                                {
                                    item_id: opt.cart_sn,
                                    item_name: opt.product_s,
                                    item_brand: "Formosa Plastic Corporation",
                                    item_category: opt.product_b,
                                    item_category2: opt.product_m,
                                    item_category3: opt.product_s,
                                    price: opt.price,
                                    quantity: opt.qty
                                }
                            ]
                        }
                    });
                    
                }catch(error) {

                    this.catchError({
                        error: error,
                        callback: () => {
                            this.removeFromCart(opt);
                        },
                    });
                }
            },
            hide: function(){
                this.$emit('sendEvent', 'hide');
            },
            next: function(){
                this.$router.push('/system/cartList');
                this.hide();
            },
        },
    }
</script>

<style scoped lang="scss">

    .animate-enter-active {
        animation: animate-in 300ms;
    }

    .animate-leave-active {
        animation: animate-out 400ms;
    }

    $top: 75px;

    @keyframes animate-in {
        0% {
            opacity: 0;
            top: $top - 20px;
        }

        100% {
            opacity: 1;
            top: $top;
        }
    }

    @keyframes animate-out {
        0% {
            opacity: 1;
            top: $top;
        }

        100% {
            opacity: 0;
            top: 0;
        }
    }


    .md.shopping-area {
        position: fixed;
        right: 60px;
        top: $top;

        &.is-loading {
            
            .shopping-area-inner {
                position: relative;

                &::v-deep {

                    .md.loading {
                        height: 160px;
                    }
                }
            }
        }

        .shopping-area-inner {
            max-height: calc(100vh - 150px);
            min-width: 250px;
            display: flex;
            flex-direction: column;
            background-color: $white;
            border: $border;
            padding: $interval-m;
            border-radius: $border-radius;
            box-shadow: $box-shadow;

            @include media('phone'){
                width: calc(100vw - 130px);
            }
        }

        .cp.caption {
            flex-shrink: 0;
            position: relative;
            font-size: $font-size-xl;
            border-bottom: $border;
            padding-bottom: $interval-m;
            
            .name {

            }

            .remove {
                $size: 20px;

                position: absolute;
                top: 0;
                right: 0;
                bottom: $interval-m;
                width: $size;
                opacity: $opacity-l;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;

                &:hover {
                    opacity: 1;
                }

                &::after {
                    content: '\e5cd';
                    @extend %font-pseudo;
                    display: block;
                    width: $size;
                    height: $size;
                    text-align: center;
                    line-height: $size;
                    font-size: $font-size-xl;
                    transition: $transition;
                }
            }
        }

        .list {
            @extend %reset;
            margin: $interval-m 0;
            flex: 1;
            flex-shrink: 1;
            overflow: auto;
            
            li {
                position: relative;
                padding: $interval-s 0;
                
                + li {
                    border-top: $border;
                }

                .remove {
                    $size: 20px;

                    position: absolute;
                    top: $interval-m;
                    right: $interval-m;
                    cursor: pointer;
                    opacity: $opacity-h;
                    transition: $transition;

                    &::before {
                        @extend %font-pseudo;
                        content: '\e5cd';
                        width: $size;
                        height: $size;
                        line-height: $size;
                        text-align: center;
                        color: $white;
                        font-size: $font-size-l;
                        border-radius: $size;
                        background-color: $deep;
                    }

                    &:hover {
                        opacity: 1;
                    }
                }
            }
        }

        .div {
            display: flex;

            .image {
                position: relative;
                width: 120px;
            }

            .mask {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                background-size: cover;
                background-position: center;
                background-color: $minor-color;
                border-radius: $border-radius;
            }

            img {
                display: none; 
            }
        }

        .essay {
            padding: $interval-m;
            line-height: $line-height-s;

            @include media('phone'){
                padding: 0;
                padding-left: $interval-m;
            }

            > .label {
                display: inline-block;
                top: $interval-s;
                left: $interval-s;
                white-space: nowrap;
                color: $white;
                padding: $interval-xs $interval-s;
                font-size: $font-size-s;
                font-weight: 900;
                text-shadow: 1px 1px 2px $gray;
                border-radius: $border-radius;
                border-color: $minor-color;
                background-color: $tag-color;

                // &.spec {
                //     background-image: image-url('spec.png');
                // }

                // &.hot {
                //     background-image: image-url('hot.png');
                // }

                // &.new {
                //     background-image: image-url('new.png');
                // }

                // &.sale {
                //     background-image: image-url('sale.png');
                // }
            }

            .caption {
                margin: $interval-s 0;
                font-weight: bold;

                @include media('phone'){
                    padding-top: $interval-m;
                }
            }

            .p {
                display: flex;

                @include media('phone'){
                    display: block;
                }

                div {
                    padding-right: $interval-m;
                    white-space: nowrap;

                    @include media('phone'){
                        padding-top: $interval-s;
                        padding-right: 0;
                        white-space: normal;
                    }
                }

                .type {

                }

                .price {
                    $type: map-get($colors, 'danger');
                    $text: map-get($type, 'text');

                    flex: 1;
                    color: $text;
                }

                .product-class {
                    
                }
            }
        }

        .btn-area {
            flex-shrink: 0;
        }
    }
</style>
